import styled from 'styled-components';

export default {
  Overlay: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
  `,

  Container: styled.div`
    max-width: 500px;
    padding: 0 16px;
    box-sizing: border-box;
    text-align: center;
    user-select: none;

    button {
      font-weight: bold;
      cursor: pointer;
    }
  `,

  Description: styled.div`
    font-size: 24px;
    margin-bottom: 8px;
    color: white;
  `,
};
